import * as yup from "yup";

export const createLocationValidationSchema = (params: { translate: any }) => {
  const { translate } = params;
  const schema = yup.object().shape({
    locationName: yup.string().nullable().required(translate("youMustEnterALocationName")),
    contactPerson: yup.string().nullable().required(translate("youMustEnterAContactPerson")),
    status: yup.string().nullable().required(translate("youMustEnterAStatus")),
    address: yup.string().nullable().required(translate("youMustEnterAnAddress")),
  });

  return schema;
}